/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function arrayCopy(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = arrayCopy;



/*****************
 ** WEBPACK FOOTER
 ** ./~/fluxxor/~/lodash/internal/arrayCopy.js
 ** module id = 73
 ** module chunks = 46 47
 **/